<template>
	<transition name="slide-fade" mode="out-in">
		<div class="center-contain">
			<left-nav></left-nav>
			<div class="center-right">
				<div class="myInfo-box">
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>登录账号<span class="opacity-0">空空</span><span class="weight-b color-333">{{info.vipAccount}}</span>
					</div>
					<div class="height-50 flex-row1 color-666 border-b-ddd">
						<span class="opacity-0">空空空</span>账号类型<span class="opacity-0">空空</span><span class="weight-b color-333">{{userInfo.userAccountType}}</span>
					</div>
					<div class="height-10"></div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>真实姓名<span class="opacity-0">空空</span>
						<div class="width50">
							<el-input v-model="info.realName" size="small" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>绑定手机<span class="opacity-0">空空</span>
						<div class="width50 flex-row2">
							<div class="weight-b color-333">{{info.passwordMobile?info.passwordMobile:'未绑定'}}</div>
							<a href="https://account.glodon.com/security/mobilebind" class="flex-row1 color-blue" @click="$util.userBehavior('1039')">
								{{info.passwordMobile?'修改':'立即'}}绑定 <img class="arrow-r" src="../../../static/icon/arrow-blue.png">
							</a>
						</div>
					</div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>绑定邮箱<span class="opacity-0">空空</span>
						<div class="width50 flex-row2">
							<div class="weight-b color-333">{{info.email?info.email:'未绑定'}}</div>
							<a href="https://account.glodon.com/security/emailbind" class="flex-row1 color-blue" @click="$util.userBehavior('1040')">
								{{info.email?'修改':'立即'}}绑定 <img class="arrow-r" src="../../../static/icon/arrow-blue.png">
							</a>
						</div>
					</div>
					<div class="height-50 flex-row1 color-666 border-b-ddd">
						<span class="opacity-0">空空空</span>联系地址<span class="opacity-0">空空</span>
						<div class="width50 flex-row2">
							<el-select v-model="info.province" placeholder="请选择" size="small" style="width: 100%;" @change="initCity()">
							    <el-option
							      v-for="item in provinceArr"
							      :key="item.code"
							      :label="item.name"
							      :value="item.code"
							      >
							    </el-option>
							</el-select>
							<el-select v-model="info.city" placeholder="请选择" size="small" style="width: 100%;" @change="initZone()">
							    <el-option
							      v-for="item in cityArr"
							      :key="item.code"
							      :label="item.name"
							      :value="item.code"
							      >
							    </el-option>
							</el-select>
							<el-select v-model="info.zone" placeholder="请选择" size="small" style="width: 100%;">
							    <el-option
							      v-for="item in zoneArr"
							      :key="item.code"
							      :label="item.name"
							      :value="item.code"
							      >
							    </el-option>
							</el-select>
						</div>
					</div>
					<div class="height-10"></div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>公司名称<span class="opacity-0">空空</span>
						<div class="width50">
							<el-input v-model="info.company" size="small" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>公司类型<span class="opacity-0">空空</span>
						<div class="width50">
							<el-select v-model="info.companyType" placeholder="请选择" size="small" style="width: 100%;">
							    <el-option
							      v-for="item in companyType"
							      :key="item.value"
							      :label="item.name"
							      :value="item.value"
							      >
							    </el-option>
							</el-select>
						</div>
					</div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空</span>工作性质<span class="opacity-0">空空</span>
						<div class="width50">
							<el-select v-model="info.duty" placeholder="请选择" size="small" style="width: 100%;">
							    <el-option
							      v-for="item in workType"
							      :key="item.value"
							      :label="item.name"
							      :value="item.value"
							      >
							    </el-option>
							</el-select>
						</div>
					</div>
					<div class="height-50 flex-row1 color-666">
						<span class="opacity-0">空空空.</span>联系QQ<span class="opacity-0">空空</span>
						<div class="width50">
							<el-input v-model="info.qq" size="small" placeholder="请输入内容"></el-input>
						</div>
					</div>
					<div class="height-50"></div>
					<div class="text-c"><el-button class="width-200" type="primary" @click="confirm()">保存</el-button></div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
module.exports = require("./index.js")

</script>

<style lang="less" scoped>
@import "./style.less";
</style>
